/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";

export class VendorTagDtoModel extends JSONable {
  uuid: string | undefined = undefined;
  value: string | undefined = undefined;
  vendorUuid: string | undefined = undefined;

  constructor(value?: string) {
    super();
    this.value = value ? value : undefined;
    this.uuid = undefined;
  }
}
